import { MimaButton, MimaInput } from '@/components';
import { IDefaultObject } from '@/interfaces';
import React, { Dispatch, FC, SetStateAction } from 'react';
import { useFormState, UseFormTrigger } from 'react-hook-form';

export interface ISignupPhase {
  setSignupPhase: Dispatch<SetStateAction<number>>;
  //   goBack?: () => void;
  control: any;
  touchedFields: any;
  //   socialTypeValue?: string;
  //   countryValue?: string;
  setValue?: any;
  trigger: UseFormTrigger<IDefaultObject>;
}

const SignupPhase1: FC<ISignupPhase> = ({ setSignupPhase, control, trigger, touchedFields }) => {
  const nextStageHandler = async () => {
    const fields = ['fullname', 'tradingName', 'mobile', 'email', 'businessRegNum'];
    const output = await trigger(fields as string[], { shouldFocus: true });

    if (!output) return;
    setSignupPhase(2);
  };

  const { errors } = useFormState({ control });

  return (
    <div>
      <MimaInput
        labelTitle="Full Name"
        placeholder="Firstname Middlename Lastname"
        id="fullname"
        name="fullname"
        error={errors.fullname}
        touched={touchedFields.fullname}
        control={control}
        mb={1}
      />

      <MimaInput
        labelTitle="Business Name"
        placeholder="Enter your Business name"
        id="tradingName"
        name="tradingName"
        error={errors.tradingName}
        touched={touchedFields.tradingName}
        control={control}
        mb={1}
      />

      <MimaInput
        labelTitle="Business Email"
        placeholder="Enter your Business Email"
        id="email"
        name="email"
        error={errors.email}
        touched={touchedFields.email}
        control={control}
        mb={1}
      />

      <MimaInput
        labelTitle="Phone Number"
        type="tel"
        placeholder="Enter your mobile number"
        id="mobile"
        name="mobile"
        error={errors.mobile}
        touched={touchedFields.mobile}
        mb={1}
        control={control}
      />

      <MimaInput
        labelTitle="Business Registration Number (Optional)"
        placeholder="Enter your business reg. number"
        id="businessRegNum"
        name="businessRegNum"
        error={errors.businessRegNum}
        touched={touchedFields.businessRegNum}
        mb={1}
        control={control}
      />

      <MimaButton
        title="Continue"
        onClick={(e) => {
          e.preventDefault();
          nextStageHandler();
        }}
      />
    </div>
  );
};

export default SignupPhase1;
